import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Equipment } from '../../models/equipment';

const initialState: EditEquipmentState = {
  visible: false,
  addVisible: false,
  equipmentId: 0
};

export interface EditEquipmentState {
  visible: boolean;
  addVisible: boolean;
  equipmentId: number;
}

export const slice = createSlice({
  name: 'editEquipment',
  initialState: initialState,
  reducers: {
    show: (state, action: PayloadAction<number>) => {
      state.visible = true;
      state.equipmentId = action.payload;
    },
    showAdd: (state) => {
      state.addVisible = true;
    },
    hide: (state) => {
      state.visible = false;
      state.addVisible = false;
    },
    addEquipmentFulfilled: (state, action: PayloadAction<Equipment>) => {
      state.visible = false;
      state.addVisible = false;
    },
    patchEquipmentFulfilled: (state, action: PayloadAction<Equipment>) => {
      state.visible = false;
      state.addVisible = false;
    },
    deleteEquipmentFulfilled: (state, action: PayloadAction<number>) => {
      state.visible = false;
      state.addVisible = false;
    }
  }
});

export default slice.reducer;
export const { show, showAdd, hide, addEquipmentFulfilled, patchEquipmentFulfilled, deleteEquipmentFulfilled } = slice.actions;
